export default __webpack_public_path__ + "static/media/receiving.f43fdfe0.svg";